// src/Redux/statusSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  statuses: {},
  isLoaded: false,
};

const statusSlice = createSlice({
  name: "status",
  initialState,
  reducers: {
    setStatuses: (state, action) => {
      if (!state.isLoaded) {
        state.statuses = action.payload;
        state.isLoaded = true; // ✅ Lock it after first set
      }
    },
  },
});

export const { setStatuses } = statusSlice.actions;

export default statusSlice.reducer;
